import React, { createContext, useContext, useState } from "react";
import { apiUrls } from "../utils/api/apiUrls";
import { getItem, removeItem, setItem } from "../utils/localStorage";
import apiClient from "../utils/api/apiClient";
import { toast } from "react-toastify";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getInitialUser());
  const [loading, setLoading] = useState(false);

  function getInitialUser() {
    const accessToken = getItem("access_token");

    if (accessToken) {
      return { access_token: accessToken };
    }

    return null;
  }

  const login = async (username, password) => {
    try {
      setLoading(true);
      const response = await apiClient.post(apiUrls.auth.accessToken, {
        username,
        password,
      });
      if (
        response?.data?.data &&
        [200, 201, 202, 203, 204].includes(response?.data?.code)
      ) {
        setUser({
          access_token: response.data?.data?.access_token,
          refresh_token: response.data?.data?.refresh_token,
        });
        setItem("access_token", response.data?.data?.access_token);
        setItem("refresh_token", response.data?.data?.refresh_token);
        const resp = await apiClient.get(apiUrls.user.profile);
        setUser({
          ...resp.data?.data,
          access_token: response.data?.data?.access_token,
          refresh_token: response.data?.data?.refresh_token,
        });
        toast.success("Successfully logged in");
      }
    } catch (error) {
      if (
        error?.response?.data?.code === 406 &&
        error?.response?.data?.message
      ) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    setUser(null);
    removeItem("access_token");
    removeItem("refresh_token");
    await apiClient.get(apiUrls.auth.logout);
  };

  const contextValue = {
    user,
    setUser,
    login,
    logout,
    loading,
    setLoading,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
